import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CmsEntities } from 'client/data/models/cms';
import { Link } from 'site-modules/shared/components/link/link';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';

export function HelpfulTipsCard({ className, content }) {
  const { title, 'promo-text': preview, 'link-url': linkUrl } = content.getAllMetadata();

  return (
    <div className={classnames('advice-container text-gray-darker', className)}>
      <Link to={linkUrl} className="d-block">
        <p className="title mb-0 size-16 fw-bold">{title}</p>
        {!!preview && (
          <ContentFragment
            componentToUse="p"
            classes="preview text-gray-darker text-decoration-none d-inline-block w-100 mb-0 size-16"
          >
            {preview}
          </ContentFragment>
        )}
      </Link>
    </div>
  );
}

HelpfulTipsCard.propTypes = {
  className: PropTypes.string,
  content: CmsEntities.Content.isRequired,
};

HelpfulTipsCard.defaultProps = {
  className: '',
};
